import LayoutV2 from "containers/LayoutV2";
import { formatNumber } from "utils/currencyFormat";
import ThongTinVon from "./tab1/ThongTinVon";
import ThongTinLai from "./tab1/ThongTinLai";
import ThongTinHopDong from "./tab1/ThongTinHopDong";
import ThongTinThuChi from "./tab1/ThongTinThuChi";
import ThongTinChungTab2 from "./tab2/ThongTinChungTab2";
import UserApi from "service/userApi";
import DanhSachCuaHangApi from "service/danhSachCuaHangApi";
import { pushNotification } from "utils/notifications";
import React, { useState, useEffect } from "react";

const ChiTietCuaHang = () => {
    const [loading, setLoading] = useState(true);
    const [CuaHangHienTai, setCuaHangHienTai] = useState([]);
    const [hasPermission, setHasPermission] = useState(null);
    const [CuaHang_ThongTinVon, setThongTinVon] = useState([]);
    const [CuaHang_ThongTinLai, setThongTinLai] = useState([]);
    const [CuaHang_ThongTinHopDong, setThongTinHopDong] = useState([]);
    const [CuaHang_ThongTinThuChi, setThongTinThuChi] = useState([]);
    const [CuaHang_CamDo, setCamDo] = useState([]);
    const [CuaHang_TinChap, setTinChap] = useState([]);
    const [CuaHang_TraGop, setTraGop] = useState([]);
    const [CuaHang_NhanVay, setNhanVay] = useState([]);
    useEffect(() => {
        document.title = "Chi tiết cửa hàng | Phần mềm quản lý cầm đồ Morman";
        fetchPermission();
    }, []);
    const fetchPermission = async () => {
        try {
            const res = await UserApi.getAllQuyen();
            const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
            setHasPermission(roles.includes("chitietcuahang1"));
        } catch (err) {
            console.error("Lỗi load quyền:", err);
            setHasPermission(false);
        }
    };
    const onLoadCuaHangHienTai = async () => {
        try {
            const res = await DanhSachCuaHangApi.CuaHangHienTai();
            setCuaHangHienTai(res.data || []);
        } catch (error) {
            console.error("Lỗi load Thông tin cửa hàng:", error);
        }
    };
    const onLoadChiTietCuaHang = async () => {
        try {
            setLoading(true);
            const res = await DanhSachCuaHangApi.ChiTietCuaHang();
            const data = res.data || {};
            setThongTinVon(data.ThongTinVon || []);
            setThongTinLai(data.ThongTinLai || []);
            setThongTinHopDong(data.ThongTinHopDong || []);
            setThongTinThuChi(data.ThuChi || []);
            setCamDo(data.CamDo || []);
            setTinChap(data.TinChap || []);
            setTraGop(data.TraGop || []);
            setNhanVay(data.nhanvay || []);
        } catch (error) {
            console.error("Lỗi load chi tiết cửa hàng:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (hasPermission) {
            onLoadCuaHangHienTai();
            onLoadChiTietCuaHang();
        }
    }, [hasPermission]);
    if (hasPermission === null) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div className="loader loader-default is-active"></div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }
    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div
                            className="custom-table-cell text-center red"
                            style={{ width: "100%" }}
                        >
                            Bạn không có quyền truy cập trang này!
                        </div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }
    return (
        <LayoutV2>
            <div id="form-repeater">
                <div className="sticky-moman-bh">
                    <div className="col-12">
                        <div className="camdo-home">
                            <div className="breadcrumb-new">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 title-cd">
                                        <div className="media-home align-center-home">
                                            <div className="row header">
                                                <img
                                                    src="/app-assets/images/icon-tong-quat-cua-hang-v2.png"
                                                    alt="logo"
                                                />
                                                <h1 className="text-info-home">Quản lý đa cửa hàng - Chi tiết cửa hàng</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="card border-light mb-1 card-v2"
                            >
                                <div className="card-body card-body-v2" style={{ userSelect: "text", display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                                    <div style={{}}>
                                        <p>
                                            <img
                                                src="/app-assets/images/icon-chi-tiet-cua-hang.png"
                                                alt="logo"
                                            />
                                        </p>
                                    </div>
                                    <div className="" style={{ marginLeft: "10px", display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                                        <div style={{ marginBottom: "5px" }}>
                                            <h2 className="color7-bold">{CuaHangHienTai.Name}</h2>
                                        </div>
                                        <div>
                                            <p>
                                                <img
                                                    src="/app-assets/images/icon-dia-chi-chi-tiet-cua-hang.png"
                                                    alt="logo"
                                                />
                                                &nbsp;{CuaHangHienTai.Address}
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                <img
                                                    src="/app-assets/images/icon-dt-chi-tiet-cua-hang.png"
                                                    alt="logo"
                                                />
                                                &nbsp;{CuaHangHienTai.Phone}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%", minHeight: "505px" }}>
                                <div
                                    className="card border-light mb-1 card-v2" style={{ flex: "5", minHeight: "" }}
                                >
                                    <div className="card-body card-body-v2" style={{ userSelect: "text", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                        <div className="form store-detail" style={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%" }}>
                                            <ul className="nav nav-tabs tabMorman mt-1" style={{ borderRadius: "10px", border: "none" }}>
                                                <li className="nav-item">
                                                    <a className="nav-link active" id="base-tab1" data-toggle="tab" aria-controls="tab1" href="#thong-tin-von" aria-expanded="true">
                                                        <h4>Thông tin vốn</h4>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="base-tab2" data-toggle="tab" aria-controls="tab2" href="#thong-tin-lai" aria-expanded="false">
                                                        <h4>Thông tin lãi</h4>
                                                    </a>
                                                </li>

                                                <li className="nav-item">
                                                    <a className="nav-link" id="base-tab3" data-toggle="tab" aria-controls="tab3" href="#thong-tin-hop-dong" aria-expanded="false">
                                                        <h4>Thông tin hợp đồng</h4>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="base-tab4" data-toggle="tab" aria-controls="tab4" href="#thong-tin-thu-chi" aria-expanded="false">
                                                        <h4>Thu/Chi</h4>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content px-1 pb-1 bg-content-tab">
                                                {!loading && (<>
                                                    <div role="tabpanel" className="tab-pane  active" id="thong-tin-von" aria-expanded="true" aria-labelledby="base-tab1">
                                                        <ThongTinVon data={CuaHang_ThongTinVon} formatNumber={formatNumber} />
                                                    </div>
                                                    <div className="tab-pane" id="thong-tin-lai" aria-labelledby="base-tab2">
                                                        <ThongTinLai data={CuaHang_ThongTinLai} formatNumber={formatNumber} />
                                                    </div>
                                                    <div className="tab-pane" id="thong-tin-hop-dong" aria-labelledby="base-tab3">
                                                        <ThongTinHopDong data={CuaHang_ThongTinHopDong} formatNumber={formatNumber} />
                                                    </div>
                                                    <div className="tab-pane" id="thong-tin-thu-chi" aria-labelledby="base-tab4">
                                                        <ThongTinThuChi data={CuaHang_ThongTinThuChi} formatNumber={formatNumber} />
                                                    </div>
                                                </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="card border-light mb-1 card-v2" style={{ marginLeft: "10px", flex: "6" }}
                                >
                                    <div className="card-body card-body-v2" style={{ userSelect: "text", display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                        <div className="form store-detail" style={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%" }}>
                                            <ul className="nav nav-tabs tabMorman mt-1 " style={{ borderRadius: "10px", border: "none" }}>
                                                <li className="nav-item">
                                                    <a className="nav-link active" id="base-tab5" data-toggle="tab" aria-controls="tab5" href="#cam-do" aria-expanded="true">
                                                        <h4>Cầm đồ</h4>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="base-tab6" data-toggle="tab" aria-controls="tab6" href="#tin-chap" aria-expanded="false">
                                                        <h4>Tín chấp</h4>
                                                    </a>
                                                </li>

                                                <li className="nav-item">
                                                    <a className="nav-link" id="base-tab7" data-toggle="tab" aria-controls="tab7" href="#tra-gop" aria-expanded="false">
                                                        <h4>Trả góp</h4>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" id="base-tab8" data-toggle="tab" aria-controls="tab8" href="#huy-dong-von" aria-expanded="false">
                                                        <h4>Huy động vốn</h4>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content px-1 pb-1 bg-content-tab">
                                                {!loading && (<>
                                                    <div role="tabpanel" className="tab-pane  active" id="cam-do" aria-expanded="true" aria-labelledby="base-tab5">
                                                        <ThongTinChungTab2 data={CuaHang_CamDo} formatNumber={formatNumber} />
                                                    </div>
                                                    <div className="tab-pane" id="tin-chap" aria-labelledby="base-tab6">
                                                        <ThongTinChungTab2 data={CuaHang_TinChap} formatNumber={formatNumber} />
                                                    </div>
                                                    <div className="tab-pane" id="tra-gop" aria-labelledby="base-tab7">
                                                        <ThongTinChungTab2 data={CuaHang_TraGop} formatNumber={formatNumber} />
                                                    </div>
                                                    <div className="tab-pane" id="huy-dong-von" aria-labelledby="base-tab8">
                                                        <ThongTinChungTab2 data={CuaHang_NhanVay} formatNumber={formatNumber} />
                                                    </div>
                                                </>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && (<>
                <div className="loader loader-default is-active"></div>
            </>)}
        </LayoutV2 >
    )
}


export default ChiTietCuaHang;